<script lang="ts">
  import type { Emodel } from "../../helpers/types";

  interface Props {
    eModels: Emodel[];
  }

  let { eModels }: Props = $props();
</script>

{#if eModels.length === 0}
  <div class="bg-Neutral200 rounded-md px-1 py-2">
    <span class="text-Neutral900 pl-2 text-H4m leading-6">Kunde inte hitta några enheter</span>
  </div>
{:else}
  {#each eModels as model, index}
    {#if index === 0 || eModels[index - 1].manufacturer.mf_ID !== model.manufacturer.mf_ID}
      <div class="bg-Neutral400 rounded-md mb-0.5 px-1 py-2 {index > 0 ? 'mt-4' : ''}">
        <span class="text-Neutral900 font-bold pl-2 text-H4m leading-6"
          >{model.manufacturer.label}</span
        >
      </div>
    {/if}
    <div class="bg-Neutral200 rounded-md px-1 py-2 {eModels.length !== index ? 'mb-0.5' : ''}">
      <span class="text-Neutral900 pl-2 text-H4m leading-6">{model.fullname}</span>
    </div>
  {/each}
{/if}
